// src/api/heroSection.ts
import { API_BASE_URL, ASSET_HOST } from "../config";
import { getAdminToken } from "../auth";

const joinUrl = (base: string, path: string) =>
  `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;

export async function uploadHeroImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  const token = getAdminToken();

  const res = await fetch(`${API_BASE_URL}/admin/hero_images`, {
    method: "POST",
    body: formData,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Upload failed: ${res.status} ${text}`);
  }

  const json = await res.json();
  // backend returns { image: "/uploads/hero_images/uuid.jpg" }
  return json.image;
}

export function buildHeroImageUrl(path: string): string {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;

  // ✅ use R2 for uploaded assets
  if (ASSET_HOST && path.startsWith("/uploads/")) {
    return joinUrl(ASSET_HOST, path);
  }

  // fallback
  return joinUrl(API_BASE_URL, path);
}
